import { useEffect } from 'react'

/** OAuth 4-leg redirect 의 1단계: backend `/oauth2/authorize` 가 미인증 사용자를 여기로 보냄.
 *  쿼리스트링에 원본 OAuth params 가 그대로 — sessionStorage 에 저장 후 /login 으로. */
export function OAuthLoading() {
  useEffect(() => {
    const qs = window.location.search ? window.location.search.substring(1) : ''
    const oauthUrl = window.location.origin + '/oauth2/authorize' + (qs ? '?' + qs : '')
    fetch('/api/auth/me', { credentials: 'include' })
      .then((r) => r.ok)
      .then((authed) => {
        if (authed) {
          window.location.replace(oauthUrl)
        } else {
          sessionStorage.setItem('oauth_return_url', oauthUrl)
          window.location.replace('/login?return=' + encodeURIComponent(oauthUrl))
        }
      })
      .catch(() => {
        sessionStorage.setItem('oauth_return_url', oauthUrl)
        window.location.replace('/login?return=' + encodeURIComponent(oauthUrl))
      })
  }, [])
  return (
    <main className="content" style={{ textAlign: 'center', paddingTop: 80 }}>
      <h2>Continuing OAuth flow…</h2>
      <p style={{ color: 'var(--text-muted)' }}>Redirecting to login if needed.</p>
    </main>
  )
}
